export const NUTRITION_PLAN_INLINE_PICKER_KIND_MAIN = "main";
export const NUTRITION_PLAN_INLINE_PICKER_KIND_EQUIVALENCE = "equivalence";

function normalizeId(value) {
  const normalizedValue = String(value ?? "").trim();
  return normalizedValue || null;
}

function areInlinePickerOwnersEqual(left = null, right = null) {
  return (
    left?.mealId === right?.mealId &&
    left?.kind === right?.kind &&
    left?.optionId === right?.optionId &&
    left?.itemId === right?.itemId
  );
}

export function normalizeNutritionPlanInlinePickerOwner(owner = null) {
  const mealId = normalizeId(owner?.mealId);
  const kind =
    owner?.kind === NUTRITION_PLAN_INLINE_PICKER_KIND_EQUIVALENCE
      ? NUTRITION_PLAN_INLINE_PICKER_KIND_EQUIVALENCE
      : owner?.kind === NUTRITION_PLAN_INLINE_PICKER_KIND_MAIN
        ? NUTRITION_PLAN_INLINE_PICKER_KIND_MAIN
        : null;

  if (!mealId || !kind) {
    return null;
  }

  if (kind === NUTRITION_PLAN_INLINE_PICKER_KIND_MAIN) {
    return {
      mealId,
      kind,
      optionId: null,
      itemId: null,
    };
  }

  const optionId = normalizeId(owner?.optionId);
  const itemId = normalizeId(owner?.itemId);
  if (!optionId || !itemId) {
    return null;
  }

  return {
    mealId,
    kind,
    optionId,
    itemId,
  };
}

export function isNutritionPlanMealFoodPickerOpen({
  openInlinePickerOwner = null,
  mealId = null,
}) {
  const normalizedOpenInlinePickerOwner =
    normalizeNutritionPlanInlinePickerOwner(openInlinePickerOwner);
  const normalizedMealId = normalizeId(mealId);

  return Boolean(
    normalizedMealId &&
      normalizedOpenInlinePickerOwner?.kind ===
        NUTRITION_PLAN_INLINE_PICKER_KIND_MAIN &&
      normalizedOpenInlinePickerOwner?.mealId === normalizedMealId,
  );
}

export function isNutritionPlanEquivalentPickerOpen({
  openInlinePickerOwner = null,
  mealId = null,
  optionId = null,
  itemId = null,
}) {
  const normalizedOpenInlinePickerOwner =
    normalizeNutritionPlanInlinePickerOwner(openInlinePickerOwner);
  const normalizedMealId = normalizeId(mealId);
  const normalizedOptionId = normalizeId(optionId);
  const normalizedItemId = normalizeId(itemId);

  return Boolean(
    normalizedMealId &&
      normalizedOptionId &&
      normalizedItemId &&
      normalizedOpenInlinePickerOwner?.kind ===
        NUTRITION_PLAN_INLINE_PICKER_KIND_EQUIVALENCE &&
      normalizedOpenInlinePickerOwner?.mealId === normalizedMealId &&
      normalizedOpenInlinePickerOwner?.optionId === normalizedOptionId &&
      normalizedOpenInlinePickerOwner?.itemId === normalizedItemId,
  );
}

export function resolveNextNutritionPlanInlinePickerOwner({
  currentOwner = null,
  requestedOwner = null,
  nextOpen = false,
}) {
  const normalizedCurrentOwner =
    normalizeNutritionPlanInlinePickerOwner(currentOwner);
  const normalizedRequestedOwner =
    normalizeNutritionPlanInlinePickerOwner(requestedOwner);

  if (!normalizedRequestedOwner) {
    return normalizedCurrentOwner;
  }

  if (nextOpen) {
    return normalizedRequestedOwner;
  }

  if (!areInlinePickerOwnersEqual(normalizedCurrentOwner, normalizedRequestedOwner)) {
    return normalizedCurrentOwner;
  }

  return null;
}

export function doesNutritionPlanMealLoseFoodPickerOwnership({
  openInlinePickerOwner = null,
  mealId = null,
}) {
  const normalizedOpenInlinePickerOwner =
    normalizeNutritionPlanInlinePickerOwner(openInlinePickerOwner);
  const normalizedMealId = normalizeId(mealId);

  return Boolean(
    normalizedOpenInlinePickerOwner?.mealId &&
      normalizedMealId &&
      normalizedOpenInlinePickerOwner.mealId !== normalizedMealId,
  );
}
